import { render, staticRenderFns } from "./PropostasPrecos.vue?vue&type=template&id=719b88f5&"
import script from "./PropostasPrecos.vue?vue&type=script&lang=js&"
export * from "./PropostasPrecos.vue?vue&type=script&lang=js&"
import style0 from "./PropostasPrecos.vue?vue&type=style&index=0&id=719b88f5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports